import { isEmpty, isArray } from "lodash-es";
import queryString from "query-string";
function appendQueryParams(url, params) {
  if (!params || isEmpty(params)) {
    return url;
  }
  const query = queryString.stringify(params);
  return query ? `${url}?${query}` : url;
}
function getQueryParam(search, propName, options = {}) {
  const { index = 0 } = options;
  const params = queryString.parse(search);
  const props = params[propName];
  if (props == null) {
    return void 0;
  }
  return isArray(props) ? props[index] ?? void 0 : props;
}
function getQueryParams(search, propName) {
  const params = queryString.parse(search);
  const props = params[propName];
  if (props == null) {
    return [];
  }
  return isArray(props) ? props : [props];
}
const UNSAFE_REDIRECT_LIST = [
  // Anything looking like a URL, like `http://evil.org` or even ``//evil.org`
  /\/\//,
  // Catchall for http
  /^http/,
  // Scripts
  /javascript/,
  /data:/,
  /<.*script:/,
  /[\r\n]/,
  // See https://getcolor.atlassian.net/browse/VUL-47
  // Case: http://localhost:8888/sign-in?next=\/evil.org  `\evil.org` (with the leading backslash)
  /\\/
];
function getSafeUrl(nextUrl) {
  if (/^http.?:\/\/(home|www|providers)?\.?color.com/.test(nextUrl)) {
    return nextUrl;
  }
  if (UNSAFE_REDIRECT_LIST.some((regex) => regex.test(nextUrl))) {
    return void 0;
  }
  return nextUrl;
}
function getSafeNextQueryParam(search) {
  const nextUrl = getQueryParam(search, "next");
  if (!nextUrl) {
    return void 0;
  }
  const additionalParams = queryString.parse(search.split(nextUrl)[1] ?? "");
  return getSafeUrl(appendQueryParams(nextUrl, additionalParams));
}
function getSafeVerifyEmailNextUrlQueryParam(search) {
  const verifyEmailNextUrl = getQueryParam(search, "verifyEmailNextUrl");
  if (!verifyEmailNextUrl) {
    return void 0;
  }
  const additionalParams = queryString.parse(search.split(verifyEmailNextUrl)[1] ?? "");
  return getSafeUrl(appendQueryParams(verifyEmailNextUrl, additionalParams));
}
function toQueryString(params) {
  return `?${queryString.stringify(params)}`;
}
function stripQueryParam(search, propName) {
  const remainder = queryString.exclude(search, [propName]);
  return remainder.length > 0 ? remainder : "?";
}
function mergeQueryParams(search, updatedParams) {
  return toQueryString({
    ...queryString.parse(search),
    ...updatedParams
  });
}
function mergeQueryParam(search, propName, propValue) {
  return mergeQueryParams(search, { [propName]: propValue });
}
function getCurrentPath() {
  const { pathname, search } = window.location;
  return `${pathname}${search}`;
}
function getNextSearchString(nextUrl) {
  return mergeQueryParam("", "next", nextUrl ?? getCurrentPath());
}
function trimTrailingSlash(path) {
  return path.replace(/\/$/, "");
}
export {
  appendQueryParams as a,
  getNextSearchString as b,
  getQueryParam as c,
  getQueryParams as d,
  getSafeUrl as e,
  getSafeNextQueryParam as f,
  getCurrentPath as g,
  getSafeVerifyEmailNextUrlQueryParam as h,
  mergeQueryParams as i,
  trimTrailingSlash as j,
  mergeQueryParam as m,
  stripQueryParam as s,
  toQueryString as t
};
//# sourceMappingURL=utils-CztPRCN_.js.map
